// extracted by mini-css-extract-plugin
export default {"OrderListContainer":"styles_OrderListContainer__LKDWk","UpperViewContainer":"styles_UpperViewContainer__JZy-Q","ItemsListHeaderContainer":"styles_ItemsListHeaderContainer__BXCVX"};